import React from 'react'
import i18n from 'constants/strings'
import { PlayerStats as PlayerStatsType } from 'types/global'
import styles from './styles/match-activity.module.scss'
import { getLastPlayedDays } from 'utils/date-utils'

const MatchActivity: React.FC<PlayerStatsType> = ({
  lastPlayedSingles,
  lastPlayedDoubles,
  uniqueOpponents,
  singlesInterval,
  doublesInterval
}) => {

  return (
    <section>
      <h2>{i18n.t('strPlayerStats.matchActivityTitle')}</h2>
      <table className={styles.matchActivityTable}>
        <tbody>
          <tr>
            <th>{i18n.t('strPlayerStats.uniqueSinglesTitle')}</th>
            <td>{uniqueOpponents || i18n.t('strData.na')}</td>
          </tr>
          <tr>
            <th>{i18n.t('strPlayerStats.daysSinceLastMatchTitle')}</th>
            <td>
              {(lastPlayedSingles || lastPlayedDoubles) ?
                <> {getLastPlayedDays(lastPlayedSingles, lastPlayedDoubles)} <small>{i18n.t('strPlayerStats.days')}</small></>
                :
                i18n.t('strData.na')}
            </td>
          </tr>
          <tr>
            <th>{i18n.t('strPlayerStats.singlesIntervalTitle')}</th>
            <td>
              {singlesInterval ?
                <> {singlesInterval} <small>{i18n.t('strPlayerStats.days')}</small></>
                :
                i18n.t('strData.na')}
            </td>
          </tr>
          <tr>
            <th>{i18n.t('strPlayerStats.doublesIntervalTitle')}</th>
            <td>
              {doublesInterval ?
                <> {doublesInterval} <small>{i18n.t('strPlayerStats.days')}</small></>
                :
                i18n.t('strData.na')}
            </td>
          </tr>
        </tbody>
      </table>
    </section>

  )
}

export default MatchActivity;